import { render, staticRenderFns } from "./ServicepointAddPage.vue?vue&type=template&id=7822776a&scoped=true"
import script from "./ServicepointAddPage.vue?vue&type=script&lang=ts"
export * from "./ServicepointAddPage.vue?vue&type=script&lang=ts"
import style0 from "./ServicepointAddPage.vue?vue&type=style&index=0&id=7822776a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7822776a",
  null
  
)

export default component.exports